import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {StatusBadge} from 'shells/status-badge/status-badge';
import {SectionLabel} from 'shells/typography/section-label';

import type {
    GetPeepEngagementStats as GetPeepEngagementStatsQuery,
    GetPeepEngagementStatsVariables as GetPeepEngagementStatsQueryVariables,
} from 'nutshell-graphql-types';

import {useGetSessionUser} from '../../../core/use-get-session-user';
import GET_PEEP_ENGAGEMENT_STATS from '../../../entity-details/graphql/queries/get-peep-engagement-stats.graphql';
import {PeepEmStats} from '../../../entity-details/peep-em-stats';

import styles from './engagement-stats.module.css';

type Props = {
    contactId: string;
};

export function EngagementStats(props: Props) {
    const {data} = useQuery<GetPeepEngagementStatsQuery, GetPeepEngagementStatsQueryVariables>(
        GET_PEEP_ENGAGEMENT_STATS,
        {
            variables: {id: props.contactId},
            notifyOnNetworkStatusChange: true,
        }
    );

    const {user} = useGetSessionUser();

    const peep = data ? data.peep : null;

    if (!peep) {
        return null;
    }

    return (
        <div>
            <SectionLabel>Email engagement</SectionLabel>
            {/* @ts-expect-error */}
            {peep.hasHardBounced ? (
                <div className={styles['engagement-stats-outer-container']}>
                    <div className={styles['engagement-stats-inner-container']}>
                        <StatusBadge
                            level='alert'
                            text='Bouncing'
                            detail={
                                peep.name ? `Your emails to ${peep.name} are bouncing` : undefined
                            }
                        />
                    </div>
                    {user && user.isSupport ? (
                        <div className={styles['support-unbounce-link']}>
                            <b>Support only:</b>
                            <br />
                            <a
                                href='#'
                                className='ui-link-standard'
                                onClick={() => {
                                    unbounceContact(props.contactId);
                                }}
                            >
                                Unbounce this person
                            </a>
                        </div>
                    ) : undefined}
                </div>
            ) : undefined}
            <div>
                <PeepEmStats {...peep.engagementStats} />
            </div>
        </div>
    );
}

// @ts-expect-error
function unbounceContact(id) {
    Nut.ajax
        .post({
            url: '/support/marketing-bounce-remove-entity.json',
            data: {entityId: id},
        })
        .then(() => {
            location.reload();
        });
}
